import React, { Component } from "react";
import { useHistory, useParams } from "react-router-dom";

import client from "@culturehq/client";
import { Button, Loader, Pagination, Panel, Table, Warning } from "@culturehq/components";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import { createEntity, updateEntity, deleteEntity } from "components/admin/settings/mutations";

import OrganizationModal from "./organizations/OrganizationModal";
import OrganizationRow from "./organizations/OrganizationRow";

const createOrganization = createEntity("organizations");
const updateOrganization = updateEntity("organizations");
const deleteOrganization = deleteEntity("organizations");

class OrganizationsContext extends Component {
  state = { loading: true, organizations: [] };

  componentDidMount() {
    const { page } = this.props;

    this.fetchOrganizations(page || 1);
  }

  componentDidUpdate(prevProps) {
    const { page } = this.props;

    if (page !== prevProps?.page) {
      this.fetchOrganizations(page || 1);
    }
  }

  handlePageClick = page => {
    const { history } = this.props;

    history.push(`/admin/chq/organizations/${page}`);
  };

  handleCreate = organization => {
    this.setState(createOrganization(organization));
    this.syncProfile(organization);
  };

  handleUpdate = organization => {
    this.setState(updateOrganization(organization));
    this.syncProfile(organization);
  };

  handleDelete = organization => {
    this.setState(deleteOrganization(organization));
    this.syncProfile(organization);
  };

  syncProfile = organization => {
    const { fetchedProfile, profile } = this.props;

    if (organization.id === profile.organization.id) {
      fetchedProfile({ ...profile, organization });
    }
  };

  async fetchOrganizations(page) {
    this.setState({ loading: true });

    const { organizations, pagination } = await client.listOrganizations({ page });

    this.setState({ loading: false, organizations, pagination });
  }

  render() {
    const { organizations, loading, pagination } = this.state;

    return (
      <Panel limitWidth>
        <Panel.Heading primary>
          <Trans>Organizations</Trans>
        </Panel.Heading>
        <Panel.Body>
          <OrganizationModal onCreate={this.handleCreate}>
            {onTrigger => (
              <Button icon="plus" primary onClick={onTrigger}>
                <Trans>Add an Organization</Trans>
              </Button>
            )}
          </OrganizationModal>

          <Loader loading={loading}>
            <Table>
              <thead>
                <tr>
                  <th>Logo</th>
                  <th>Name</th>
                  <th>Created</th>
                  <th className="pull-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                {organizations.map(organization => (
                  <OrganizationRow
                    key={organization.id}
                    organization={organization}
                    onUpdate={this.handleUpdate}
                    onDelete={this.handleDelete}
                  />
                ))}
              </tbody>
            </Table>

            {organizations.length < 1 && (
              <Warning>
                <strong>Uh oh!</strong> No results to show.
              </Warning>
            )}

            <Pagination {...pagination} onClick={this.handlePageClick} />
          </Loader>
        </Panel.Body>
      </Panel>
    );
  }
}

const Organizations = props => {
  const profileState = useProfile();
  const history = useHistory();
  const { page } = useParams();

  return <OrganizationsContext {...props} history={history} page={page} {...profileState} />;
};

export default Organizations;
